import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
import { Grid as GGrid, AccordionPanel, Box, Form, FormField, Button } from 'grommet';
import Grid from '@material-ui/core/Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

var Header = function Header(props) {
  return React.createElement(GGrid, {
    fill: true,
    rows: ['50px'],
    columns: ['small', 'flex'],
    gap: 'small',
    areas: [{
      name: 'first_name',
      start: [0, 0],
      end: [0, 0]
    }, {
      name: 'last_name',
      start: [1, 0],
      end: [1, 0]
    }]
  }, React.createElement(Box, {
    justify: 'center',
    margin: {
      left: 'small'
    },
    gridArea: 'first_name'
  }, props.first_name, ' '), React.createElement(Box, {
    justify: 'center',
    gridArea: 'last_name'
  }, props.last_name, ' '));
};

export var Contact = function Contact(props) {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      edit = _React$useState2[0],
      enableEdit = _React$useState2[1];

  var toggleEdit =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(event) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!edit) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return props.save(event, props.contact);

            case 3:
              enableEdit(!edit);

            case 4:
              enableEdit(!edit);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function toggleEdit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var editIcon = function editIcon() {
    if (edit) {
      return React.createElement(FontAwesomeIcon, {
        icon: ['fas', 'save'],
        size: '2x'
      });
    }

    return React.createElement(FontAwesomeIcon, {
      icon: ['fas', 'pen'],
      size: '2x'
    });
  };

  return React.createElement(AccordionPanel, {
    label: React.createElement(Header, {
      first_name: props.contact.first_name,
      last_name: props.contact.last_name
    })
  }, React.createElement(Form, {
    value: {
      first_name: props.contact.first_name,
      last_name: props.contact.last_name,
      email: props.contact.email,
      primary_phone: props.contact.primary_phone,
      preferred_name: props.contact.preferred_name,
      pronoun: props.contact.pronoun
    },
    onSubmit: toggleEdit
  }, React.createElement(Box, {
    background: 'light-2'
  }, React.createElement(GGrid, {
    fill: true,
    rows: ['50px', 'flex'],
    columns: ['full'],
    gap: 'small',
    areas: [{
      name: 'header',
      start: [0, 0],
      end: [0, 0]
    }, {
      name: 'content',
      start: [0, 1],
      end: [0, 1]
    }]
  }, React.createElement(Box, {
    pad: 'medium',
    gridArea: 'header',
    align: 'end',
    justify: 'center',
    background: edit ? '#e28f20' : 'light-2'
  }, React.createElement(Button, {
    type: 'submit'
  }, editIcon())), React.createElement(Box, {
    pad: 'medium',
    gridArea: 'content'
  }, React.createElement(Grid, {
    container: true,
    spacing: 24
  }, React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 4
  }, React.createElement(FormField, {
    name: 'first_name',
    label: 'First Name',
    disabled: !edit
  })), React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 4
  }, React.createElement(FormField, {
    name: 'last_name',
    label: 'Last Name',
    disabled: !edit
  })), React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 4
  }, React.createElement(FormField, {
    name: 'email',
    label: 'eMail Address',
    disabled: !edit
  })), React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 4
  }, React.createElement(FormField, {
    name: 'primary_phone',
    label: 'Primary Phone',
    disabled: !edit,
    type: 'tel',
    placeholder: '###-###-####'
  })), React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 4
  }, React.createElement(FormField, {
    name: 'preferred_name',
    label: 'Preferred Name',
    disabled: !edit
  })), React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 4
  }, React.createElement(FormField, {
    name: 'pronoun',
    label: 'Pronoun',
    disabled: !edit
  }))))))));
};